import {CompleteCarImageProps} from "./CompleteCarImagesComponent";
import {useEffect} from "react";
import {MAX_FETCH_DATA_SIZE, ResourceNames} from "../../config/const";
import {convertDataForSortableImage} from "../../common/image/databaseImageUtils";

export const useCompleteCarImageHooks = (props: CompleteCarImageProps) => {

    useEffect(() => {
        const awaitFn = async () => {
            await getImages()
        };
        awaitFn().then();
    }, [props.completeCarId])

    const getImages = async () => {
        if (props.completeCarId) {
            const result = await convertDataForSortableImage(props.dataProvider,
                ResourceNames.COMPLETE_CAR_IMAGE_RESOURCE,
                {
                    pagination: {page: 1, perPage: MAX_FETCH_DATA_SIZE},
                    sort: {field: 'position', order: 'ASC'},
                    filter: {
                        completeCarId: props.completeCarId,
                        completeCarImageClass: props.completeCarImageClass,
                    }
                }
            )
            props.setImages(result);
        }
    }

}
